module.exports = __webpack_public_path__ + "static/media/exclamation-square.a245c139.svg";